































































































import { Component, Prop, Vue } from "vue-property-decorator";
import OfferDetails from "@/models/OfferDetails";

@Component
export default class SubmissionFormOfferDetails extends Vue {
  @Prop({ default: new OfferDetails() }) private offerDetails!: OfferDetails;
}
